import { Component, OnInit } from '@angular/core';
import { CandidateService } from './modules/candidate/candidate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'GTTSi-Panel';
  constructor(private candidateService: CandidateService) {}

  resumeDownloadsCountSend() {
    if (localStorage.getItem('user')) {
      this.candidateService.getTotalDownloads();
    }
  }

  ngOnInit() {
    setInterval(() => {
      this.resumeDownloadsCountSend();
      console.log('called');
    }, 5000);
  }
}
